/* istanbul ignore file */
export { default } from './version-select';
export { default as definition } from './definition';
//# sourceMappingURL=index.js.map